module.exports = __webpack_public_path__ + "static/media/cert_83.fd5e0db3.jpg";